// extracted by mini-css-extract-plugin
export default {"dataTable":"BypassQuartileGrid_dataTable__GHvIh"};